/**
 * Copyright (C) SiteVision AB 2002-2026, all rights reserved
 */
import sv from '@sv/core';
import {
  initSvAutoComplete,
  INPUT_SELECTOR,
} from '../shared/svAutoComplete/svAutoComplete';

const getSettings = (portlet, inputEl, settingsEl) => {
  const settings = {};
  if (settingsEl) {
    Object.assign(settings, settingsEl.dataset);
  }
  if (!settings.fnAutoCompleteUrl && inputEl) {
    const portletId = sv.ObjectUtil.getObjectId(portlet.id);
    Object.assign(settings, {
      fnAutoCompleteUrl: `/${sv.PageContext.pageId}/${portletId}.json?state=autoComplete`,
    });
  }
  return settings;
};

const normalizeLegacyMarkup = (formEl, inputEl, settings) => {
  // Use modern placeholder
  if (
    settings.escapedSearchHereText &&
    inputEl.value === settings.escapedSearchHereText
  ) {
    inputEl.value = '';
    if (!inputEl.hasAttribute('placeholder')) {
      inputEl.setAttribute('placeholder', settings.escapedSearchHereText);
    }
  }
};

const preventEmptySearch = (formEl, inputEl) => {
  if (formEl) {
    formEl.addEventListener('submit', (evt) => {
      if (inputEl.value.replace(/\s/g, '') === '') {
        evt.preventDefault();
        return false;
      }
    });
  }
};

const instances = new WeakMap();

export const initSearchForm = (portlet) => {
  const inputEl = portlet.querySelector(INPUT_SELECTOR);
  const formEl = inputEl ? inputEl.form || inputEl.closest('form') : null;
  if (!inputEl || !formEl || instances.has(inputEl)) {
    return;
  }
  instances.set(inputEl, true);

  const settingsEl = portlet.querySelector('.sv-searchform-portlet-settings');
  const settings = getSettings(portlet, inputEl, settingsEl);
  if (settingsEl) {
    settingsEl.parentNode.removeChild(settingsEl);
  }

  normalizeLegacyMarkup(formEl, inputEl, settings);
  preventEmptySearch(formEl, inputEl);

  if (
    settings.fnAutoCompleteUrl &&
    inputEl.dataset.useAutocomplete !== 'false'
  ) {
    initSvAutoComplete(inputEl, {
      source: settings.fnAutoCompleteUrl,
    });
  }
};
